module.exports = __webpack_public_path__ + "res/0-img_reward.eb1c44b0146dcf96b644acf6896efcf1.png";